module.exports = __webpack_public_path__ + "static/media/ic_cash-primary.502a9c5d.svg";